import type { TypeWindowKey } from '@/function/calendar/calendar.window';
import windowDays from '@/function/calendar/calendar.window.days';
import { dashboardApi } from '@/store/api/base/api.base';
import type { TypeExpenseCalendarWindow } from '@/types/expense/types.expense.calendar';

export const EXPENSE_CALENDAR_TAG = 'ExpenseCalendar' as const;

const KEEP_FOR = 300;

export const expenseCalendarApi = dashboardApi.enhanceEndpoints({ addTagTypes: [EXPENSE_CALENDAR_TAG] }).injectEndpoints({
    endpoints: (build) => ({
        listExpenseCalendarWindow: build.query<TypeExpenseCalendarWindow, TypeWindowKey>({
            query: (key) => ({ url: '/expenses/calendar', params: windowDays(key) }),
            transformResponse: (response: TypeExpenseCalendarWindow | null) => ({ items: response?.items ?? [], truncated: Boolean(response?.truncated) }),
            providesTags: [EXPENSE_CALENDAR_TAG],
            keepUnusedDataFor: KEEP_FOR,
        }),
    }),
});

export const { useListExpenseCalendarWindowQuery } = expenseCalendarApi;

export default expenseCalendarApi;
